import { Data } from '@blade/std-lib'

export type FollowingsSearchMode = (typeof searchModes)[number]

export const match = Data.matchString<FollowingsSearchMode>()
export const searchModes = ['global', 'local'] as const
